/* ============================================================
   KALA INDIA — theme behaviour (Shopify OS 2.0)
   Presentational UI + Shopify AJAX Cart. No mock cart.
============================================================ */
(function () {
  "use strict";
  var K = window.Kala || {};
  K.routes = K.routes || {};

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- money formatting (Shopify style) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var fmt = format || K.moneyFormat || "₹{{amount}}";
    function thousands(num, precision, thousandSep, decimalSep) {
      precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
      thousandSep = thousandSep == null ? "," : thousandSep;
      decimalSep = decimalSep == null ? "." : decimalSep;
      var n = (cents / 100).toFixed(precision);
      var parts = n.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousandSep);
      var dec = parts[1] ? decimalSep + parts[1] : "";
      return whole + dec;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case "amount": return thousands(2);
        case "amount_no_decimals": return thousands(0);
        case "amount_with_comma_separator": return thousands(2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return thousands(0, ".", ",");
        default: return thousands(2);
      }
    });
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = $("#kala-toast");
    if (!t) return;
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" style="width:17px;height:17px"><path d="M20 6 9 17l-5-5"/></svg>' + msg;
    t.classList.add("show");
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ---------- header + mobile menu ---------- */
  function header() {
    var h = $("[data-header]");
    if (h) {
      var onScroll = function () { h.classList.toggle("scrolled", window.scrollY > 10); };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }
    var menu = $("[data-mobile-menu]");
    var open = $("[data-menu-open]");
    var close = $("[data-menu-close]");
    if (menu && open) {
      open.addEventListener("click", function () { menu.classList.add("open"); open.setAttribute("aria-expanded", "true"); });
    }
    if (menu && close) {
      close.addEventListener("click", function () { menu.classList.remove("open"); if (open) open.setAttribute("aria-expanded", "false"); });
    }
  }

  /* ---------- hero slider ---------- */
  function heroSlider() {
    $$("[data-hero-slider]").forEach(function (root) {
      var track = $("[data-hs-track]", root);
      var slides = $$("[data-hs-slide]", root);
      var dots = $$("[data-hs-dot]", root);
      if (!track || slides.length < 2) return;
      var index = 0, timer = null;
      var autoplayMs = parseInt(root.getAttribute("data-autoplay") || "0", 10);

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = "translateX(-" + (index * 100) + "%)";
        slides.forEach(function (s, n) { s.classList.toggle("active", n === index); });
        dots.forEach(function (d, n) { d.classList.toggle("active", n === index); });
      }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }
      function start() { if (autoplayMs) { stop(); timer = setInterval(next, autoplayMs); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      var prevBtn = $("[data-hs-prev]", root), nextBtn = $("[data-hs-next]", root);
      if (prevBtn) prevBtn.addEventListener("click", function () { prev(); start(); });
      if (nextBtn) nextBtn.addEventListener("click", function () { next(); start(); });
      dots.forEach(function (d) {
        d.addEventListener("click", function () { go(parseInt(d.getAttribute("data-hs-dot"), 10)); start(); });
      });
      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);

      var touchX = null;
      root.addEventListener("touchstart", function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      root.addEventListener("touchend", function (e) {
        if (touchX == null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); start(); }
        touchX = null;
      }, { passive: true });

      go(0);
      start();
    });
  }

  /* ---------- reveal on scroll ---------- */
  function reveal() {
    var els = $$(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) { els.forEach(function (e) { e.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- reels / video reviews: tap to play ---------- */
  function playGroups() {
    function group(sel) {
      var items = $$(sel);
      items.forEach(function (it) {
        it.addEventListener("click", function (e) {
          if (e.target.closest("a")) return;
          var was = it.classList.contains("playing");
          items.forEach(function (x) { x.classList.remove("playing"); });
          if (!was) it.classList.add("playing");
        });
      });
    }
    group(".reel");
    group(".vrev");
  }

  /* ---------- product 3D tilt + story chapter sync ---------- */
  function story() {
    var tilt = $("#tilt");
    if (tilt) {
      var stage = tilt.parentElement;
      stage.addEventListener("mousemove", function (e) {
        var r = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        tilt.style.transform = "rotateY(" + (px * 16) + "deg) rotateX(" + (-py * 16) + "deg)";
      });
      stage.addEventListener("mouseleave", function () { tilt.style.transform = "rotateY(0) rotateX(0)"; });
    }
    var storyRect = $("#storysvg") && $("#storysvg").querySelector("rect");
    var storyImg = $("#storyImg");
    var chapters = $$(".chapter");
    if (chapters.length && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            chapters.forEach(function (c) { c.classList.remove("active"); });
            e.target.classList.add("active");
            if (storyRect && e.target.dataset.pat) storyRect.setAttribute("fill", "url(#" + e.target.dataset.pat + ")");
            if (storyImg && e.target.dataset.img) {
              storyImg.removeAttribute("srcset");
              storyImg.src = e.target.dataset.img;
            }
          }
        });
      }, { threshold: [0.6] });
      chapters.forEach(function (c) { io.observe(c); });
    }
  }

  /* ---------- coupon copy ---------- */
function coupons() {
  $$("[data-code], .coupon-chip[data-code]").forEach(function (c) {
    c.addEventListener("click", function () {

      var code = c.getAttribute("data-code");
      if (!code) return;

      var discount = parseFloat(c.getAttribute("data-discount")) || 0;
      var type = c.getAttribute("data-type") || "percent";

      var priceEl = document.querySelector("[data-price-now]");
      var finalPriceEl = document.querySelector("[data-cf-price]");
      var saveEl = document.querySelector("[data-cf-save]");

      if (priceEl && discount > 0) {

        // 👉 original price store (only once)
        if (!priceEl.dataset.originalPrice) {
          var clean = priceEl.textContent.replace(/[^\d.]/g, "");
          priceEl.dataset.originalPrice = clean;
        }

        var originalPrice = parseFloat(priceEl.dataset.originalPrice);

        var savedAmount = (type === "percent")
          ? (originalPrice * discount / 100)
          : discount;

        var finalPrice = originalPrice - savedAmount;

        if (finalPrice < 0) finalPrice = 0;

        // 👉 update main price
        priceEl.textContent = "₹" + finalPrice.toFixed(2);

        // 👉 update coupon final section
        if (finalPriceEl) {
          finalPriceEl.textContent = "₹" + finalPrice.toFixed(2);
        }

        if (saveEl) {
          saveEl.textContent = "₹" + savedAmount.toFixed(2);
        }
      }

      // 👉 active coupon switch
      $$(".coupon-chip").forEach(btn => btn.classList.remove("active"));
      c.classList.add("active");

      // -------------------------------
      // EXISTING CODE (unchanged)
      // -------------------------------

      if (navigator.clipboard) {
        navigator.clipboard.writeText(code);
      }

      var label = c.querySelector(".copybtn") || c;
      var orig = label.textContent;

      label.textContent = "Applying...";
      label.classList.add("loading");

      var iframe = document.getElementById("discount-frame");
      if (!iframe) {
        iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.id = "discount-frame";
        document.body.appendChild(iframe);
      }

      // 👉 clear old coupon
      iframe.src = "/discount/clear";

      // 👉 apply new coupon
      setTimeout(function () {
        iframe.src = "/discount/" + code;
      }, 400);

      // 👉 UI success
      setTimeout(function () {
        label.textContent = "✓ Applied!";
        label.classList.remove("loading");
        label.classList.add("copied");

        document.dispatchEvent(new CustomEvent("discount:applied", { detail: { code: code } }));

        setTimeout(function () {
          // label.textContent = orig;
          label.classList.remove("copied");
        }, 1600);
      }, 1200);

    });
  });
}
  /* ---------- popup ---------- */
  function popup() {
    var el = $("#kala-popup");
    if (!el) return;
    // If the form just posted successfully, show it immediately with the code.
    var posted = !!el.querySelector(".modal-reveal.show");
    if (!posted && sessionStorage.getItem("kala_pop")) return;
    var delay = parseInt(el.getAttribute("data-delay") || "6", 10) * 1000;
    var shown = false;
    function show() { if (shown) return; shown = true; el.classList.add("show"); }
    function dismiss() { el.classList.remove("show"); sessionStorage.setItem("kala_pop", "1"); }
    if (posted) { show(); }
    else {
      setTimeout(show, delay);
      document.addEventListener("mouseout", function (e) { if (e.clientY <= 0 && !e.relatedTarget) show(); });
    }
    $$("[data-popup-close]", el).forEach(function (b) { b.addEventListener("click", dismiss); });
    el.addEventListener("click", function (e) { if (e.target === el) dismiss(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") dismiss(); });
  }

  /* ---------- cart drawer ---------- */
  var Drawer = {
    el: null, overlay: null,
    init: function () {
      Drawer.el = $("[data-cart-drawer]");
      Drawer.overlay = $("[data-drawer-overlay]");
      if (!Drawer.el) return;
      $$("[data-drawer-close]").forEach(function (b) { b.addEventListener("click", Drawer.close); });
      if (Drawer.overlay) Drawer.overlay.addEventListener("click", Drawer.close);
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") Drawer.close(); });
      // Header cart icon opens the drawer instead of navigating
      var link = $(".cart-link");
      if (link) {
        link.addEventListener("click", function (e) {
          if (window.innerWidth < 750) return; // let mobile go to the cart page
          e.preventDefault();
          Drawer.open();
        });
      }
    },
    open: function () {
      if (!Drawer.el) return;
      Drawer.el.hidden = false;
      if (Drawer.overlay) Drawer.overlay.hidden = false;
      requestAnimationFrame(function () {
        Drawer.el.classList.add("open");
        if (Drawer.overlay) Drawer.overlay.classList.add("open");
      });
      document.body.style.overflow = "hidden";
    },
    close: function () {
      if (!Drawer.el) return;
      Drawer.el.classList.remove("open");
      if (Drawer.overlay) Drawer.overlay.classList.remove("open");
      document.body.style.overflow = "";
      setTimeout(function () {
        if (!Drawer.el.classList.contains("open")) {
          Drawer.el.hidden = true;
          if (Drawer.overlay) Drawer.overlay.hidden = true;
        }
      }, 400);
    },
    // Re-render the drawer server-side via the Section Rendering API
    refresh: function () {
      return fetch(K.routes.cart + "?section_id=cart-drawer")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-cart-drawer]");
          var current = $("[data-cart-drawer]");
          if (fresh && current) {
            var wasOpen = current.classList.contains("open");
            current.innerHTML = fresh.innerHTML;
            bindCartLines();
            $$("[data-drawer-close]", current).forEach(function (b) { b.addEventListener("click", Drawer.close); });
            if (wasOpen) current.classList.add("open");
          }
        })
        .catch(function () { /* drawer section not available — silently ignore */ });
    }
  };

  /* ==========================================================
     SHOPIFY CART
  ========================================================== */
  function getCart() {
    return fetch(K.routes.cart + ".js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
  }

  function updateCartUI(cart) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
    });
    // free-ship progress (cart page)
    var bar = $("#ship-bar"), msg = $("#ship-msg");
    if (bar || msg) {
      var threshold = (K.freeShipThreshold || 1499) * 100;
      var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      if (bar) bar.style.width = pct + "%";
      if (msg) {
        if (cart.total_price >= threshold) {
          msg.innerHTML = "🎉 You've unlocked <b>free shipping!</b>";
        } else {
          var remain = formatMoney(threshold - cart.total_price);
          msg.innerHTML = "You're <b>" + remain + "</b> away from <b>free shipping</b>";
        }
      }
    }
  }

  function refreshCart() { return getCart().then(updateCartUI); }

  function addToCart(items, btn) {
    if (btn) { btn.classList.add("loading"); btn.disabled = true; }
    return fetch(K.routes.cart_add, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw res.data;
        toast((K.strings && K.strings.added) || "Added to cart");
        return refreshCart().then(Drawer.refresh).then(Drawer.open);
      })
      .catch(function (err) {
        toast((err && err.description) || "Sorry, couldn't add that.");
      })
      .then(function () { if (btn) { btn.classList.remove("loading"); btn.disabled = false; } });
  }

  function changeLine(payload) {
    return fetch(K.routes.cart_change, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  var onCartPage = function () { return document.body.classList.contains("template-cart"); };

  // Bound separately so the drawer can re-bind after a section re-render.
  function bindCartLines() {
    $$("[data-line-qty]").forEach(function (wrap) {
      if (wrap._bound) return;
      wrap._bound = true;
      var line = wrap.getAttribute("data-line");
      var input = wrap.querySelector("input");
      wrap.querySelectorAll("[data-qc]").forEach(function (b) {
        b.addEventListener("click", function () {
          var q = parseInt(input.value, 10) || 1;
          q = b.getAttribute("data-qc") === "1" ? q + 1 : Math.max(0, q - 1);
          changeLine({ line: parseInt(line, 10), quantity: q }).then(function () {
            if (onCartPage()) window.location.reload();
            else { refreshCart(); Drawer.refresh(); }
          });
        });
      });
    });
    $$("[data-line-remove]").forEach(function (b) {
      if (b._bound) return;
      b._bound = true;
      b.addEventListener("click", function (e) {
        e.preventDefault();
        changeLine({ line: parseInt(b.getAttribute("data-line-remove"), 10), quantity: 0 }).then(function () {
          if (onCartPage()) window.location.reload();
          else { refreshCart(); Drawer.refresh(); }
        });
      });
    });
  }

  function bindCart() {
    // Add-to-cart forms (product page)
    $$("[data-atc-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var id = form.querySelector('[name="id"]');
        if (!id || !id.value) return;
        var qtyEl = form.querySelector('[name="quantity"]');
        var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        addToCart([{ id: parseInt(id.value, 10), quantity: qty }], form.querySelector('[type="submit"]'));
      });
    });
    // Quick-add buttons on product cards
    $$("[data-add-to-cart]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var vid = btn.getAttribute("data-variant-id");
        if (!vid) return;
        addToCart([{ id: parseInt(vid, 10), quantity: 1 }], btn);
      });
    });
    // Sticky "Buy now" — add to cart, then go straight to checkout
    $$("[data-buy-now]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var vid = btn.getAttribute("data-variant-id");
        if (!vid) return;
        btn.classList.add("loading");
        btn.disabled = true;
        fetch(K.routes.cart_add, {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw res.data;
            window.location.href = "/checkout";
          })
          .catch(function (err) {
            toast((err && err.description) || "Sorry, couldn't add that.");
            btn.classList.remove("loading");
            btn.disabled = false;
          });
      });
    });
    bindCartLines();
  }

  /* ---------- pincode / COD checker ---------- */
  function pincode() {
    var btn = $("#pinbtn"), input = $("#pin"), out = $("#pinres");
    if (!btn || !input || !out) return;
    btn.addEventListener("click", function () {
      var v = (input.value || "").trim();
      out.hidden = false;
      if (!/^\d{6}$/.test(v)) {
        out.style.color = "var(--terracotta)";
        out.textContent = "Please enter a valid 6-digit pincode.";
        return;
      }
      out.style.color = "";
      out.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:15px;height:15px"><path d="M20 6 9 17l-5-5"/></svg> Delivers in 3–5 days · COD available · Free shipping';
    });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") btn.click(); });
  }

  /* ---------- product variant picker ---------- */
  /* ---------- product variant picker ---------- */
  function variantPicker() {
    var root = $("[data-product-json]");
    if (!root) return;
    var product;
    try { product = JSON.parse(root.textContent); } catch (e) { return; }
    var form = $("[data-atc-form]");
    if (!form) return;

    var idField = form.querySelector('[name="id"]');
    var atc = form.querySelector('[type="submit"]');
    var stickyBtn = $("#sticky [data-add-to-cart]");
    var buyNowBtns = $$("[data-buy-now]");

    // One entry per option position (not per radio input) — this was the bug.
    function selectedOptions() {
      var opts = [];
      (product.options || []).forEach(function (_, i) {
        var pos = i + 1;
        var checked = form.querySelector('input[name="option' + pos + '"]:checked');
        if (checked) { opts[i] = checked.value; return; }
        var sel = form.querySelector('select[data-option-index="' + pos + '"]');
        if (sel) opts[i] = sel.value;
      });
      return opts;
    }

    function match() {
      var opts = selectedOptions();
      if (!opts.length) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    // Disable option values that produce no purchasable variant.
    function updateAvailability(current) {
      var opts = selectedOptions();
      $$('input[data-option-index]', form).forEach(function (input) {
        var pos = parseInt(input.getAttribute("data-option-index"), 10);
        var trial = opts.slice();
        trial[pos - 1] = input.value;
        var exists = product.variants.some(function (v) {
          for (var j = 0; j < trial.length; j++) { if (v.options[j] !== trial[j]) return false; }
          return v.available;
        });
        input.disabled = !exists;
      });
    }

    function update() {
      var v = match();
      if (!v) return;

      if (idField) idField.value = v.id;
      if (stickyBtn) stickyBtn.setAttribute("data-variant-id", v.id);
      buyNowBtns.forEach(function (b) { b.setAttribute("data-variant-id", v.id); });

      // Update every price node (buy box AND sticky bar).
      $$("[data-price-now]").forEach(function (el) { el.textContent = formatMoney(v.price); });
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      $$("[data-price-mrp]").forEach(function (el) {
        if (onSale) { el.textContent = formatMoney(v.compare_at_price); el.hidden = false; }
        else { el.hidden = true; }
      });
      $$("[data-price-off]").forEach(function (el) {
        if (onSale) {
          var pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
          el.textContent = "Save " + formatMoney(v.compare_at_price - v.price) + " (" + pct + "%)";
          el.hidden = false;
        } else { el.hidden = true; }
      });

      // Live coupon maths (final price after code).
      var cf = $("[data-coupon-final]");
      if (cf) {
        var rate = parseFloat(cf.getAttribute("data-coupon-rate") || "0");
        if (rate > 0) {
          var final = Math.round(v.price * (1 - rate / 100));
          var totalSave = (onSale ? v.compare_at_price - v.price : 0) + (v.price - final);
          var fEl = cf.querySelector("[data-cf-price]");
          var sEl = cf.querySelector("[data-cf-save]");
          if (fEl) fEl.textContent = formatMoney(final);
          if (sEl) sEl.textContent = formatMoney(totalSave);
        }
      }

      // Selected-option labels.
      (product.options || []).forEach(function (name, i) {
        var lbl = $('[data-option-selected="' + (i + 1) + '"]');
        if (lbl) lbl.textContent = selectedOptions()[i] || "";
      });

      // Swap gallery to the variant's image.
      if (v.featured_media && v.featured_media.id) {
        var t = $('.thumb[data-media-id="' + v.featured_media.id + '"]');
        if (t) t.click();
      }

      // Buy buttons.
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? (atc.getAttribute("data-label") || "Add to cart") : "Coming Soon";
      }
      if (stickyBtn) stickyBtn.disabled = !v.available;
      buyNowBtns.forEach(function (b) { b.disabled = !v.available; });
      var buyNowRow = $("[data-buynow-row]");
      if (buyNowRow) buyNowRow.hidden = !v.available;

      updateAvailability(v);

      // Keep the URL shareable.
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState({}, "", url.toString());
      }
    }

    $$("[data-option-index]", form).forEach(function (el) { el.addEventListener("change", update); });
    update();
  }

  /* ---------- qty steppers (generic) ---------- */
  function qtySteppers() {
    $$(".qty").forEach(function (q) {
      var input = q.querySelector("input");
      if (!input) return;
      q.querySelectorAll("button[data-q]").forEach(function (b) {
        b.addEventListener("click", function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.getAttribute("data-q") === "1" ? v + 1 : Math.max(1, v - 1);
          input.value = v;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---------- auto-convert numbered "FAQ" text in rich-text content into accordions ---------- */
  function richTextFaq() {
    $$(".rte").forEach(function (rte) {
      $$("h1,h2,h3,h4", rte).forEach(function (h) {
        var label = h.textContent.trim().toLowerCase().replace(/[^a-z]/g, "");
        if (label !== "faq" && label !== "faqs") return;
        var node = h.nextElementSibling;
        while (node) {
          if (/^H[1-4]$/.test(node.tagName)) break;
          if (node.tagName !== "P" || !/^\s*\d+[.)]\s+/.test(node.textContent)) {
            node = node.nextElementSibling;
            continue;
          }
          var qEl = node, aEl = qEl.nextElementSibling;
          if (!aEl) break;
          var next = aEl.nextElementSibling;
          var item = document.createElement("div");
          item.className = "faq-item";
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "faq-q";
          btn.innerHTML = qEl.innerHTML.replace(/^\s*\d+[.)]\s+/, "") +
            ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 5v14M5 12h14"/></svg>';
          var ans = document.createElement("div");
          ans.className = "faq-a";
          ans.innerHTML = aEl.innerHTML;
          item.appendChild(btn);
          item.appendChild(ans);
          qEl.replaceWith(item);
          aEl.remove();
          node = next;
        }
      });
    });
  }

  /* ---------- FAQ accordions ---------- */
  function faq() {
    $$(".faq-q").forEach(function (q) {
      q.addEventListener("click", function () {
        var item = q.closest(".faq-item") || q.parentElement;
        item.classList.toggle("open");
      });
    });
  }

  /* ---------- sticky ATC ---------- */
  function stickyBar() {
    var s = $("#sticky");
    if (!s) return;
    window.addEventListener("scroll", function () { s.classList.toggle("show", window.scrollY > 700); }, { passive: true });
  }

  /* ---------- discount code (cart page) ----------
     Shopify applies codes at checkout; /discount/CODE stores it on the session. */
  function discountCode() {
    var btn = $("#apply-coupon"), field = $("#coupon-field");
    if (!btn || !field) return;
    function apply() {
      var code = (field.value || "").trim();
      if (!code) return;
      btn.classList.add("loading");
      window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(K.routes.cart_url || "/cart");
    }
    btn.addEventListener("click", apply);
    field.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); apply(); } });
  }

  /* ---------- product media gallery ---------- */
  function gallery() {
    var thumbs = $$(".thumb");
    if (!thumbs.length) return;
    var mainSvg = $("#mainsvg");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
        // Pattern placeholder mode
        var pat = t.getAttribute("data-pat");
        if (pat && mainSvg) {
          var rect = mainSvg.querySelector("rect");
          if (rect) rect.setAttribute("fill", "url(#" + pat + ")");
          return;
        }
        // Real Shopify media mode
        var id = t.getAttribute("data-media-id");
        if (!id) return;
        $$(".media-item").forEach(function (m) {
          var show = m.getAttribute("data-media-id") === id;
          m.hidden = !show;
          if (!show) {
            var vid = m.querySelector("video");
            if (vid && !vid.paused) vid.pause();
          }
        });
      });
    });
  }

  /* ---------- wishlist (localStorage) ---------- */
  var WISHLIST_KEY = "kala_wishlist";

  function getWishlist() {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { raw = []; }
    return raw.map(function (entry) {
      if (entry && typeof entry === "object") return { id: String(entry.id), handle: entry.handle || "" };
      return { id: String(entry), handle: "" };
    });
  }
  function setWishlist(entries) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(entries)); } catch (e) {}
  }
  function updateWishlistCount() {
    var count = getWishlist().length;
    $$("[data-wishlist-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  function paintWishlistButtons() {
    var ids = getWishlist().map(function (e) { return e.id; });
    $$("[data-wishlist][data-product-id]").forEach(function (btn) {
      var active = ids.indexOf(String(btn.getAttribute("data-product-id"))) !== -1;
      btn.classList.toggle("active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }
  function wishlist() {
    updateWishlistCount();
    paintWishlistButtons();
    $$("[data-wishlist][data-product-id]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = String(btn.getAttribute("data-product-id"));
        var handle = btn.getAttribute("data-product-handle") || "";
        var entries = getWishlist();
        var i = entries.map(function (en) { return en.id; }).indexOf(id);
        if (i === -1) {
          entries.push({ id: id, handle: handle });
          toast((K.strings && K.strings.wishlistAdded) || "Added to wishlist");
        } else {
          entries.splice(i, 1);
          toast((K.strings && K.strings.wishlistRemoved) || "Removed from wishlist");
        }
        setWishlist(entries);
        paintWishlistButtons();
        updateWishlistCount();
        if (WishlistDrawer.el && WishlistDrawer.el.classList.contains("open")) WishlistDrawer.render();
      });
    });
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function renderWishItem(p) {
    var variant = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { variant = p.variants[i]; break; }
    }
    if (!variant) variant = p.variants[0];
    var imgUrl = p.featured_image || (p.images && p.images[0]) || "";
    var imgTag = imgUrl
      ? '<img src="' + imgUrl + (imgUrl.indexOf("?") === -1 ? "?" : "&") + 'width=200" alt="' + escapeHtml(p.title) + '" loading="lazy">'
      : "";
    var priceHtml = '<span class="ci-now">' + formatMoney(variant.price) + "</span>";
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceHtml += '<span class="ci-mrp">' + formatMoney(variant.compare_at_price) + "</span>";
    }
    var atcHtml = variant.available
      ? '<button type="button" class="btn btn-primary" style="padding:8px 16px;font-size:13px" data-wish-add-to-cart data-variant-id="' + variant.id + '">Add to cart</button>'
      : '<span class="ci-meta">Sold out</span>';
    return (
      '<div class="cart-item">' +
        '<a href="' + p.url + '" class="ci-img">' + imgTag + "</a>" +
        '<div class="ci-info">' +
          '<h4><a href="' + p.url + '">' + escapeHtml(p.title) + "</a></h4>" +
          '<div class="ci-actions">' + atcHtml + '<button type="button" class="ci-remove" data-wish-remove="' + p.id + '">Remove</button></div>' +
        "</div>" +
        '<div class="ci-right">' + priceHtml + "</div>" +
      "</div>"
    );
  }

  var WishlistDrawer = {
    init: function () {
      WishlistDrawer.el = $("[data-wishlist-drawer]");
      WishlistDrawer.overlay = $("[data-wishlist-drawer-overlay]");
      WishlistDrawer.body = $("[data-wishlist-drawer-body]");
      if (!WishlistDrawer.el) return;
      $$("[data-wishlist-drawer-close]").forEach(function (b) { b.addEventListener("click", WishlistDrawer.close); });
      if (WishlistDrawer.overlay) WishlistDrawer.overlay.addEventListener("click", WishlistDrawer.close);
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") WishlistDrawer.close(); });
      $$("[data-wishlist-count-holder]").forEach(function (b) {
        b.addEventListener("click", function (e) {
          e.preventDefault();
          WishlistDrawer.open();
        });
      });
    },
    open: function () {
      if (!WishlistDrawer.el) return;
      WishlistDrawer.el.hidden = false;
      if (WishlistDrawer.overlay) WishlistDrawer.overlay.hidden = false;
      requestAnimationFrame(function () {
        WishlistDrawer.el.classList.add("open");
        if (WishlistDrawer.overlay) WishlistDrawer.overlay.classList.add("open");
      });
      WishlistDrawer.render();
    },
    close: function () {
      if (!WishlistDrawer.el) return;
      WishlistDrawer.el.classList.remove("open");
      if (WishlistDrawer.overlay) WishlistDrawer.overlay.classList.remove("open");
      setTimeout(function () {
        if (!WishlistDrawer.el.classList.contains("open")) {
          WishlistDrawer.el.hidden = true;
          if (WishlistDrawer.overlay) WishlistDrawer.overlay.hidden = true;
        }
      }, 300);
    },
    render: function () {
      if (!WishlistDrawer.body) return;
      var entries = getWishlist();
      var countEl = $("[data-wishlist-drawer-count]");
      if (countEl) countEl.textContent = "(" + entries.length + ")";
      var emptyEl = WishlistDrawer.body.querySelector("[data-wishlist-empty]");
      var itemsEl = WishlistDrawer.body.querySelector("[data-wishlist-items]");
      if (!emptyEl || !itemsEl) return;
      if (entries.length === 0) {
        emptyEl.hidden = false;
        itemsEl.hidden = true;
        itemsEl.innerHTML = "";
        return;
      }
      var withHandle = entries.filter(function (e) { return e.handle; });
      itemsEl.hidden = false;
      emptyEl.hidden = true;
      itemsEl.innerHTML = '<p style="text-align:center;color:var(--ink-faint);padding:30px 0">Loading…</p>';
      Promise.all(withHandle.map(function (e) {
        return fetch("/products/" + e.handle + ".js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var valid = products.filter(Boolean);
        if (valid.length === 0) {
          emptyEl.hidden = false;
          itemsEl.hidden = true;
          itemsEl.innerHTML = "";
          return;
        }
        itemsEl.innerHTML = valid.map(renderWishItem).join("");
        itemsEl.querySelectorAll("[data-wish-remove]").forEach(function (b) {
          b.addEventListener("click", function () {
            var id = b.getAttribute("data-wish-remove");
            setWishlist(getWishlist().filter(function (e) { return e.id !== id; }));
            paintWishlistButtons();
            updateWishlistCount();
            WishlistDrawer.render();
          });
        });
        itemsEl.querySelectorAll("[data-wish-add-to-cart]").forEach(function (b) {
          b.addEventListener("click", function () {
            var vid = b.getAttribute("data-variant-id");
            if (!vid) return;
            addToCart([{ id: parseInt(vid, 10), quantity: 1 }], b);
          });
        });
      });
    }
  };

  /* ---------- year ---------- */
  function year() { var y = $("#year"); if (y) y.textContent = new Date().getFullYear(); }

  /* ---------- init ---------- */
  ready(function () {
    header();
    heroSlider();
    reveal();
    playGroups();
    story();
    coupons();
    popup();
    Drawer.init();
    bindCart();
    variantPicker();
    gallery();
    qtySteppers();
    richTextFaq();
    faq();
    stickyBar();
    pincode();
    discountCode();
    wishlist();
    WishlistDrawer.init();
    year();
    refreshCart();
  });
})();
